import { render, staticRenderFns } from "./shjjzb.vue?vue&type=template&id=0010095a&"
import script from "./shjjzb.vue?vue&type=script&lang=js&"
export * from "./shjjzb.vue?vue&type=script&lang=js&"
import style0 from "./shjjzb.vue?vue&type=style&index=0&id=0010095a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports